import React from "react";
import { Box, keyframes } from "@mui/material";

/** Un solo pase L→R (como login, sin bucle). */
const paintOnce = keyframes`
  0% {
    opacity: 0.2;
    clip-path: inset(0 100% 0 0);
  }
  100% {
    opacity: 1;
    clip-path: inset(0 0 0 0);
  }
`;

const wellIn = keyframes`
  from { opacity: 0; transform: scale(0.92); }
  to { opacity: 1; transform: scale(1); }
`;

/** Stagger estable por id de widget (0 … ~0.5s). */
export function staggerFromId(id, step = 0.05) {
  const s = String(id || "x");
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h + s.charCodeAt(i) * (i + 1)) % 11;
  }
  return h * step;
}

/**
 * Envuelve el icono del pozo: se “pinta” una vez al montar.
 */
export default function DashIconDraw({
  children,
  delay = 0,
  sx: sxProp,
  ...rest
}) {
  return (
    <Box
      {...rest}
      sx={[
        {
          display: "grid",
          placeItems: "center",
          animation: `${wellIn} 0.45s ease both`,
          animationDelay: `${delay}s`,
          "@media (prefers-reduced-motion: reduce)": {
            animation: "none",
          },
          "& .MuiSvgIcon-root, & > svg": {
            animation: `${paintOnce} 0.85s cubic-bezier(0.22, 1, 0.36, 1) both`,
            animationDelay: `${delay + 0.08}s`,
            "@media (prefers-reduced-motion: reduce)": {
              animation: "none",
              opacity: 1,
              clipPath: "none",
            },
          },
        },
        ...(Array.isArray(sxProp) ? sxProp : sxProp ? [sxProp] : []),
      ]}
    >
      {children}
    </Box>
  );
}
